import * as React from 'react';
import { Onboarding } from './components/Onboarding';
import './styles.scss';
import { onLoad } from './init';

window.onload = () => onLoad(<Onboarding />);
